package io.horion.cv.components.preview

import androidx.compose.runtime.Composable
import io.horion.cv.api.datasource.cv.OrionCV
import com.varabyte.kobweb.compose.css.*
import com.varabyte.kobweb.compose.css.AlignItems
import com.varabyte.kobweb.compose.css.JustifyContent
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*

@Composable
fun CvSevenPreview(data: OrionCV) {
    val pi = data.personalInformation
    val validPersonalizedSections =
        data.personalizedSections.filter { section ->
            section.resume.isNotBlank() ||
                    section.started.isNotBlank() ||
                    section.ended.isNotBlank() ||
                    section.description.isNotBlank()
        }

    val validFormations = data.formations.filter {
        it.school.isNotBlank() || it.label.isNotBlank() ||
                it.started.isNotBlank() || it.ended.isNotBlank() ||
                it.description.isNotBlank()
    }
    val validExperiences = data.experiences.filter {
        it.post.isNotBlank() || it.enterprise.isNotBlank() || it.city.isNotBlank() ||
                it.started.isNotBlank() || it.ended.isNotBlank() ||
                it.description.any { d -> d.isNotBlank() }
    }
    val validStages = data.stages.filter {
        it.post.isNotBlank() || it.enterprise.isNotBlank() || it.city.isNotBlank() ||
                it.started.isNotBlank() || it.ended.isNotBlank() || it.description.isNotBlank()
    }
    val validLearns = data.learns.filter {
        it.label.isNotBlank() || it.started.isNotBlank() || it.ended.isNotBlank() ||
                it.description.isNotBlank()
    }
    val validActivities = data.extracurricularActivities.filter {
        it.name.isNotBlank() || it.enterprise.isNotBlank() || it.city.isNotBlank() ||
                it.started.isNotBlank() || it.ended.isNotBlank() || it.description.isNotBlank()
    }
    val validCertificates = data.certificates.filter {
        it.name.isNotBlank() || it.date.isNotBlank() || it.description.isNotBlank()
    }
    val validCompetences = data.competences.filter { it.name.isNotBlank() }
    val validAchievements = data.achievements.filter { it.isNotBlank() }
    val validReferences = data.references.filter {
        it.name.isNotBlank() || it.enterprise.isNotBlank() || it.city.isNotBlank() ||
                it.phone.isNotBlank() || it.email.isNotBlank()
    }
    val validSoftware = data.software.filter { it.name.isNotBlank() }
    val validHobbies = data.hobbies.filter { it.isNotBlank() }

    val darkGray = Color("#333333")
    val lightTextColor = Color("#FFFFFF")
    val darkTextColor = Color("#000000")
    val accentBlue = Color("#1A73E8")
    val softGray = Color("#EEEEEE")

    Style {
        """
    .cv-seven-preview,
    .cv-seven-preview * {
        box-sizing: border-box;
    }

    .cv-seven-preview p,
    .cv-seven-preview div,
    .cv-seven-preview span,
    .cv-seven-preview a,
    .cv-seven-preview li,
    .cv-seven-preview h1,
    .cv-seven-preview h2,
    .cv-seven-preview h3 {
        max-width: 100%;
        min-width: 0;
        white-space: normal;
        overflow-wrap: anywhere;
        word-break: break-word;
    }

    .cv-seven-preview img {
        max-width: 100%;
        height: auto;
    }
    """.trimIndent()
    }

    Div(attrs = {
        attr("class", "cv-seven-preview")
        style {
            display(DisplayStyle.Flex)
            width(794.px)
            property("max-width", "100%")
            property("min-width", "0")
            minHeight(1123.px)
            fontFamily("Inter", "sans-serif")
            backgroundColor(Color("#FFFFFF"))
            property("box-sizing", "border-box")
            property("overflow", "hidden")
        }
    }) {
        // --- SIDEBAR GAUCHE ---
        Div(attrs = {
            style {
                width(300.px)
                backgroundColor(softGray)
                color(darkTextColor)
                display(DisplayStyle.Flex)
                flexDirection(FlexDirection.Column)
                position(Position.Relative)
                property("width", "300px")
                property("min-width", "300px")
                property("max-width", "300px")
                property("flex-shrink", "0")
                property("overflow", "hidden")
                overflow(Overflow.Hidden)
                boxSizing("border-box")

            }
        }) {
            // Capsule sombre du haut (arrondie en bas) : photo + nom
            Div(attrs = {
                style {
                    backgroundColor(darkGray)
                    color(lightTextColor)
                    property("border-radius", "0 0 50% 50%")
                    padding(40.px, 20.px, 45.px)
                    textAlign(TextAlign.Center)
                    display(DisplayStyle.Flex)
                    flexDirection(FlexDirection.Column)
                    alignItems(AlignItems.Center)
                }
            }) {
                H1(attrs = {
                    style {
                        width(100.percent)
                        property("max-width", "100%")
                        property("min-width", "0")
                        margin(0.px)
                        fontSize(24.px)
                        fontWeight("bold")
                        lineHeight("1.2")
                        property("white-space", "normal")
                        property("overflow-wrap", "anywhere")
                        property("word-break", "break-word")
                    }
                }) {
                    Text(pi.lastName.uppercase())
                }

                H2(attrs = {
                    style {
                        width(100.percent)
                        property("max-width", "100%")
                        property("min-width", "0")
                        margin(5.px)
                        fontSize(18.px)
                        fontWeight("300")
                        lineHeight("1.2")
                        property("white-space", "normal")
                        property("overflow-wrap", "anywhere")
                        property("word-break", "break-word")
                    }
                }) {
                    Text(pi.firstName)
                }

                H3(attrs = {
                    style {
                        width(100.percent)
                        property("max-width", "100%")
                        property("min-width", "0")
                        margin(5.px)
                        fontSize(14.px)
                        fontWeight("normal")
                        lineHeight("1.3")
                        opacity(0.8)
                        property("white-space", "normal")
                        property("overflow-wrap", "anywhere")
                        property("word-break", "break-word")
                    }
                }) {
                    Text(pi.bp.uppercase())
                }

                Div(attrs = {
                    style {
                        width(140.px); height(140.px)
                        borderRadius(50.percent)
                        marginTop(20.px)
                        overflow(Overflow.Hidden)
                        backgroundColor(Color("#FFFFFF"))
                    }
                }) {
                    if (pi.photo.isNotBlank()) {
                        Img(src = pi.photo, attrs = { style { width(100.percent); height(100.percent); property("object-fit", "cover") } })
                    }
                }
            }

            // Bloc central (fond clair) : texte foncé
            Div(attrs = { style { color(darkTextColor) } }) {

                // CONTACT
                val location = listOfNotNull(
                    pi.city.takeIf { it.isNotBlank() },
                    pi.state.takeIf { it.isNotBlank() },
                    pi.country.takeIf { it.isNotBlank() }
                ).joinToString(", ")
                val hasWebsite = pi.siteWeb?.second?.isNotBlank() == true
                val hasLinks   = pi.links.any { it.second.isNotBlank() }
                if (pi.email.isNotBlank() || pi.phone.isNotBlank() || pi.address.isNotBlank() || location.isNotBlank() || hasWebsite || hasLinks) {
                    Cv7SidebarSectionTitle("CONTACT")
                    Div(attrs = { style { padding(0.px, 30.px); fontSize(12.px) } }) {
                        if (pi.address.isNotBlank()) Cv7ContactRow(PreviewIcons.MAP_PIN, pi.address)
                        else if (location.isNotBlank()) Cv7ContactRow(PreviewIcons.MAP_PIN, location)
                        if (pi.phone.isNotBlank()) Cv7ContactRow(PreviewIcons.PHONE, pi.phone)
                        if (pi.email.isNotBlank()) Cv7ContactRow(PreviewIcons.MAIL, pi.email)
                        pi.siteWeb?.let { (_, url) -> if (url.isNotBlank()) Cv7ContactLinkRow(url) }
                        pi.links.forEach { (_, url) -> if (url.isNotBlank()) Cv7ContactLinkRow(url) }
                    }
                }

                // INFORMATIONS
                val hasBirth   = pi.birth.isNotBlank()
                val hasNat     = pi.nationality.isNotBlank()
                val hasMarital = pi.maritalStatus.isNotBlank()
                val hasLicense = pi.drivingLicense.isNotBlank()
                if (hasBirth || hasNat || hasMarital || hasLicense) {
                    Cv7SidebarSectionTitle("INFORMATIONS")
                    Div(attrs = { style { padding(0.px, 30.px) } }) {
                        if (hasBirth)   Cv7SidebarRow("Né le", pi.birth)
                        if (hasNat)     Cv7SidebarRow("Nationalité", pi.nationality)
                        if (hasMarital) Cv7SidebarRow("Sit. fam.", pi.maritalStatus)
                        if (hasLicense) Cv7SidebarRow("Permis", pi.drivingLicense)
                    }
                }

                // LANGUES (niveau réel)
                Div(attrs = {
                    style {
                        width(100.percent)
                        property("max-width", "100%")
                        property("min-width", "0")
                        padding(0.px, 30.px)
                    }
                }) {
                    data.languages.forEach { lang ->
                        Div(attrs = {
                            style {
                                width(100.percent)
                                property("max-width", "100%")
                                property("min-width", "0")
                                marginBottom(10.px)
                                fontSize(12.px)
                                lineHeight("1.4")
                                property("white-space", "normal")
                                property("overflow-wrap", "anywhere")
                                property("word-break", "break-word")
                            }
                        }) {
                            Span(attrs = {
                                style {
                                    fontWeight("bold")
                                    property("overflow-wrap", "anywhere")
                                }
                            }) {
                                Text("${lang.language.name.uppercase()} : ")
                            }

                            Span {
                                Text(lang.level.name.replace("_", " "))
                            }
                        }
                    }
                }

                // QUALITÉS
                Div(attrs = {
                    style {
                        width(100.percent)
                        property("max-width", "100%")
                        property("min-width", "0")
                        padding(0.px, 30.px)
                        fontSize(12.px)
                        lineHeight("1.4")
                        property("white-space", "normal")
                        property("overflow-wrap", "anywhere")
                        property("word-break", "break-word")
                    }
                }) {
                    data.qualities.forEach { quality ->
                        Div(attrs = {
                            style {
                                width(100.percent)
                                property("max-width", "100%")
                                property("min-width", "0")
                                marginBottom(8.px)
                                property("overflow-wrap", "anywhere")
                                property("word-break", "break-word")
                            }
                        }) {
                            Text(quality)
                        }
                    }
                }
            }

            // EDUCATION : arche sombre arrondie en haut, touche le bas de page
            if (validFormations.isNotEmpty()) {
                Div(attrs = {
                    style {
                        property("margin-top", "auto")
                        backgroundColor(darkGray)
                        color(lightTextColor)
                        padding(30.px)
                        property("border-radius", "50% 50% 0 0")
                    }
                }) {
                    Cv7SidebarSectionTitle("EDUCATION", iconPath = PreviewIcons.BOOK_OPEN, iconColor = "#000000", iconBg = "#FFFFFF")
                    validFormations.forEach { form ->
                        Div(attrs = { style { marginBottom(15.px) } }) {
                            Div(attrs = { style { fontWeight("bold"); fontSize(13.px) } }) { Text(form.school.uppercase()) }
                            Div(attrs = { style { fontSize(11.px); opacity(0.9) } }) { Text(form.label) }
                            Div(attrs = { style { fontSize(10.px); fontStyle(FontStyle.Italic); opacity(0.7) } }) { Text(formatPeriod(form.started, form.ended)) }
                            if (form.description.isNotBlank()) {
                                Div(attrs = { style { fontSize(10.px); opacity(0.85); marginTop(3.px) } }) { HtmlInline(form.description) }
                            }
                        }
                    }
                }
            }
        }

        // --- CONTENU DROITE ---
        Div(attrs = {
            style {
                flex(1)
                property("width", "0")
                property("min-width", "0")
                property("max-width", "100%")
                property("overflow", "hidden")
                padding(40.px)
                display(DisplayStyle.Flex)
                flexDirection(FlexDirection.Column)
                boxSizing("border-box")
            }
        }) {
            // PROFIL
            if (!data.profil.isNullOrBlank()) {
                Cv7MainTitle("PROFIL", PreviewIcons.USER)
                Cv7SectionBody {
                    HtmlBlock(data.profil) {
                        fontSize(12.px); color(darkGray); lineHeight("1.6")
                    }
                }
            }

            // RUBRIQUES PERSONNALISÉES
            if (validPersonalizedSections.isNotEmpty()) {
                validPersonalizedSections.forEach { section ->
                    Cv7PersonalizedSection(
                        section = section,
                        darkGray = darkGray
                    )
                }
            }

            // EXPÉRIENCES PROFESSIONNELLES
            if (validExperiences.isNotEmpty()) {
                Cv7MainTitle("EXPÉRIENCES PROFESSIONNELLES", PreviewIcons.BRIEFCASE)
                Cv7SectionBody {
                    validExperiences.forEach { exp ->
                        Cv7ExpItem(exp.post, exp.enterprise, exp.city, formatPeriod(exp.started, exp.ended), exp.description, accentBlue, darkGray)
                    }
                }
            }

            // STAGES
            if (validStages.isNotEmpty()) {
                Cv7MainTitle("STAGES", PreviewIcons.BOOK_OPEN)
                Cv7SectionBody {
                    validStages.forEach { stage ->
                        Cv7ExpItem(stage.post, stage.enterprise, stage.city, formatPeriod(stage.started, stage.ended),
                            if (stage.description.isNotBlank()) listOf(stage.description) else emptyList(), accentBlue, darkGray)
                    }
                }
            }

            // COURS
            if (validLearns.isNotEmpty()) {
                Cv7MainTitle("COURS", PreviewIcons.BOOK_OPEN)
                Cv7SectionBody {
                    validLearns.forEach { learn ->
                        Cv7ExpItem(learn.label, "", "", formatPeriod(learn.started, learn.ended),
                            if (learn.description.isNotBlank()) listOf(learn.description) else emptyList(), accentBlue, darkGray)
                    }
                }
            }

            // ACTIVITÉS EXTRA-SCOLAIRES
            if (validActivities.isNotEmpty()) {
                Cv7MainTitle("ACTIVITÉS EXTRA-SCOLAIRES", PreviewIcons.AWARD)
                Cv7SectionBody {
                    validActivities.forEach { activity ->
                        Cv7ExpItem(activity.name, activity.enterprise, activity.city, formatPeriod(activity.started, activity.ended),
                            if (activity.description.isNotBlank()) listOf(activity.description) else emptyList(), accentBlue, darkGray)
                    }
                }
            }

            // CERTIFICATS
            if (validCertificates.isNotEmpty()) {
                Cv7MainTitle("CERTIFICATS", PreviewIcons.FILE_TEXT)
                Cv7SectionBody {
                    validCertificates.forEach { cert ->
                        Cv7ExpItem(cert.name, "", "", extractYear(cert.date),
                            if (cert.description.isNotBlank()) listOf(cert.description) else emptyList(), accentBlue, darkGray)
                    }
                }
            }

            // COMPÉTENCES (texte simple séparé par des virgules, plus de box)
            if (validCompetences.isNotEmpty()) {
                Cv7MainTitle("COMPÉTENCES", PreviewIcons.BAR_CHART)
                Cv7SectionBody {
                    Div(attrs = { style { fontSize(12.px); color(darkGray); lineHeight("1.7") } }) {
                        Text(validCompetences.joinToString(", ") { it.name })
                    }
                }
            }

            // RÉALISATIONS
            if (validAchievements.isNotEmpty()) {
                Cv7MainTitle("RÉALISATIONS", PreviewIcons.TROPHY)
                Cv7SectionBody {
                    Ul(attrs = { style { paddingLeft(20.px); margin(0.px); fontSize(11.px); color(darkGray) } }) {
                        validAchievements.forEach { item -> Li(attrs = { style { marginBottom(6.px) } }) { HtmlInline(item) } }
                    }
                }
            }

            // RÉFÉRENCES
            if (validReferences.isNotEmpty()) {
                Cv7MainTitle("RÉFÉRENCES", PreviewIcons.ID_CARD)
                Cv7SectionBody {
                    validReferences.forEach { ref ->
                        Div(
                            attrs = {
                                style {
                                    marginBottom(14.px)
                                    property("width", "100%")
                                    property("max-width", "100%")
                                    property("min-width", "0")
                                    property("overflow", "hidden")
                                } }) {
                            Div(
                                attrs = {
                                    style {
                                        fontWeight("bold");
                                        fontSize(13.px)
                                        property("white-space", "normal")
                                        property("overflow-wrap", "anywhere")
                                        property("word-break", "break-word")
                                    } }) { Text(ref.name) }
                            val subtitleParts = listOfNotNull(ref.enterprise.takeIf { it.isNotBlank() }, ref.city.takeIf { it.isNotBlank() })
                            if (subtitleParts.isNotEmpty()) {
                                Div(
                                    attrs = {
                                        style {
                                            color(accentBlue);
                                            fontWeight("bold");
                                            fontSize(11.px);
                                            marginTop(2.px)
                                            property("white-space", "normal")
                                            property("overflow-wrap", "anywhere")
                                            property("word-break", "break-word")
                                        } }) { Text(subtitleParts.joinToString(" · ")) }
                            }
                            val contactParts = listOfNotNull(ref.phone.takeIf { it.isNotBlank() }, ref.email.takeIf { it.isNotBlank() })
                            if (contactParts.isNotEmpty()) {
                                Div(
                                    attrs = {
                                        style {
                                            fontSize(11.px);
                                            color(darkGray);
                                            marginTop(2.px)
                                            property("white-space", "normal")
                                            property("overflow-wrap", "anywhere")
                                            property("word-break", "break-word")
                                        } }) { Text(contactParts.joinToString("   •   ")) }
                            }
                        }
                    }
                }
            }

            // SIGNATURE
            data.signature?.let { sig ->
                if (sig.city.isNotBlank() || sig.date.isNotBlank() || sig.image.isNotBlank()) {
                    Div(attrs = {
                        style {
                            marginTop(10.px)
                            marginBottom(20.px)
                            display(DisplayStyle.Flex)
                            justifyContent(JustifyContent.FlexEnd)
                            width(100.percent)
                            property("max-width", "100%")
                            property("min-width", "0")
                            property("overflow", "hidden")
                        } }) {
                        Div(attrs = {
                            style {
                                width(100.percent)
                                property("max-width", "100%")
                                property("min-width", "0")
                                textAlign(TextAlign.Right)
                                property("white-space", "normal")
                                property("overflow-wrap", "anywhere")
                                property("word-break", "break-word")
                            } }) {
                            val line = listOfNotNull(sig.city.takeIf { it.isNotBlank() }, sig.date.takeIf { it.isNotBlank() })
                            if (line.isNotEmpty()) {
                                Div(attrs = { style { fontSize(11.px); color(Color("#777777")) } }) { Text(line.joinToString(", ")) }
                            }
                            if (sig.image.isNotBlank()) {
                                Img(
                                    src = sig.image,
                                    attrs = {
                                        style {
                                            property("display", "inline-block")
                                            property("max-width", "100%")
                                            height(50.px)
                                            property("object-fit", "contain")
                                            marginTop(4.px)
                                        }
                                    }
                                )
                            }
                        }
                    }
                }
            }

            // LOGICIELS & HOBBIES (ligne du bas)
            Div(attrs = { style { display(DisplayStyle.Flex); gap(40.px); property("margin-top", "auto") } }) {
                if (validSoftware.isNotEmpty()) {
                    Div(attrs = { style { flex(1) } }) {
                        Cv7MainTitle("LOGICIELS", PreviewIcons.MONITOR)
                        Cv7SectionBody {
                            validSoftware.forEach { soft ->
                                Div(attrs = { style { marginBottom(10.px) } }) {
                                    Div(attrs = { style { fontSize(11.px); marginBottom(4.px) } }) { Text(soft.name) }
                                    Div(attrs = { style { width(100.percent); height(6.px); backgroundColor(Color("#EEEEEE")) } }) {
                                        val pct = (soft.stars.coerceIn(0, 5) * 20)
                                        Div(attrs = { style { width(pct.percent); height(100.percent); backgroundColor(Color("#000000")) } })
                                    }
                                }
                            }
                        }
                    }
                }

                if (validHobbies.isNotEmpty()) {
                    Div(attrs = { style { flex(1) } }) {
                        Cv7MainTitle("HOBBIES", PreviewIcons.SMILE)
                        Cv7SectionBody {
                            Div(
                                attrs = {
                                    style {
                                        display(DisplayStyle.Grid);
                                        property("grid-template-columns", "minmax(0, 1fr) minmax(0, 1fr)");
                                        gap(10.px);
                                        fontSize(11.px)
                                    } }) {
                                validHobbies.forEach { hobby ->
                                    Div(attrs = {
                                        style {
                                            display(DisplayStyle.Flex)
                                            width(100.percent)
                                            property("max-width", "100%")
                                            property("min-width", "0")
                                            alignItems(AlignItems.FlexStart)
                                        }
                                    }) {
                                        Div(attrs = {
                                            style {
                                                width(6.px)
                                                height(6.px)
                                                borderRadius(50.percent)
                                                backgroundColor(darkGray)
                                                marginRight(8.px)
                                                marginTop(4.px)
                                                property("flex-shrink", "0")
                                            }
                                        })

                                        Span(attrs = {
                                            style {
                                                property("min-width", "0")
                                                property("max-width", "100%")
                                                property("white-space", "normal")
                                                property("overflow-wrap", "anywhere")
                                                property("word-break", "break-word")
                                            }
                                        }) {
                                            Text(hobby)
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}


@Composable
private fun Cv7SectionBody(content: @Composable () -> Unit) {
    Div(attrs = { style {
        property("margin-top", "-4px")
        property("margin-bottom", "18px")
    }}) { content() }
}

@Composable
private fun Cv7SidebarSectionTitle(
    title: String,
    iconPath: String? = null,
    iconColor: String = "#000000",
    iconBg: String = "#FFFFFF"
) {
    Div(attrs = { style { display(DisplayStyle.Flex); alignItems(AlignItems.Center); padding(20.px, 30.px, 10.px) } }) {
        if (iconPath != null) {
            Div(attrs = {
                style { width(24.px); height(24.px); backgroundColor(Color(iconBg)); borderRadius(50.percent); marginRight(10.px); display(DisplayStyle.Flex); alignItems(AlignItems.Center); justifyContent(JustifyContent.Center) }
            }) { PreviewIcon(iconPath, color = iconColor, size = 14) }
        }
        H3(attrs = { style { margin(0.px); fontSize(16.px); fontWeight("bold"); letterSpacing(1.px) } }) { Text(title) }
    }
}

@Composable
private fun Cv7SidebarRow(
    label: String,
    value: String
) {
    Div(attrs = {
        style {
            width(100.percent)
            property("max-width", "100%")
            property("min-width", "0")
            marginBottom(12.px)
        }
    }) {
        Div(attrs = {
            style {
                property("max-width", "100%")
                fontSize(11.px)
                fontWeight("bold")
                opacity(0.7)
            }
        }) {
            Text(label)
        }

        Div(attrs = {
            style {
                property("max-width", "100%")
                fontSize(12.px)
                lineHeight("1.4")
                property("white-space", "normal")
                property("overflow-wrap", "anywhere")
                property("word-break", "break-word")
            }
        }) {
            Text(value)
        }
    }
}

@Composable
private fun Cv7ContactRow(
    iconPath: String,
    value: String
) {
    Div(attrs = {
        style {
            display(DisplayStyle.Flex)
            width(100.percent)
            property("max-width", "100%")
            property("min-width", "0")
            alignItems(AlignItems.FlexStart)
            marginBottom(10.px)
        }
    }) {
        Div(attrs = {
            style {
                width(18.px)
                height(18.px)
                marginRight(10.px)
                display(DisplayStyle.Flex)
                alignItems(AlignItems.Center)
                justifyContent(JustifyContent.Center)
                property("flex-shrink", "0")
            }
        }) {
            PreviewIcon(iconPath, color = "#000000", size = 15)
        }

        Span(attrs = {
            style {
                property("width", "0")
                property("flex", "1")
                property("min-width", "0")
                property("max-width", "100%")
                property("line-height", "1.4")
                property("white-space", "normal")
                property("overflow-wrap", "anywhere")
                property("word-break", "break-word")
            }
        }) {
            Text(value)
        }
    }
}

@Composable
private fun Cv7ContactLinkRow(url: String) {
    Div(attrs = {
        style {
            display(DisplayStyle.Flex)
            width(100.percent)
            property("max-width", "100%")
            property("min-width", "0")
            alignItems(AlignItems.FlexStart)
            marginBottom(10.px)
        }
    }) {
        Div(attrs = {
            style {
                width(18.px)
                height(18.px)
                marginRight(10.px)
                display(DisplayStyle.Flex)
                alignItems(AlignItems.Center)
                justifyContent(JustifyContent.Center)
                property("flex-shrink", "0")
            }
        }) {
            PreviewIcon(
                PreviewIcons.LINK,
                color = "#000000",
                size = 15
            )
        }

        A(
            href = url,
            attrs = {
                attr("target", "_blank")
                attr("rel", "noopener noreferrer")

                style {
                    property("width", "0")
                    property("flex", "1")
                    property("min-width", "0")
                    property("max-width", "100%")
                    color(Color("#1A73E8"))
                    property("line-height", "1.4")
                    property("white-space", "normal")
                    property("overflow-wrap", "anywhere")
                    property("word-break", "break-word")
                    property("text-decoration", "underline")
                }
            }
        ) {
            Text(url)
        }
    }
}

@Composable
private fun Cv7MainTitle(
    title: String,
    iconPath: String
) {
    Div(attrs = {
        style {
            display(DisplayStyle.Flex)
            width(100.percent)
            property("max-width", "100%")
            property("min-width", "0")
            alignItems(AlignItems.Center)
            marginBottom(8.px)
            marginTop(8.px)
        }
    }) {
        Div(attrs = {
            style {
                width(32.px)
                height(32.px)
                backgroundColor(Color("#000000"))
                borderRadius(50.percent)
                marginRight(15.px)
                display(DisplayStyle.Flex)
                alignItems(AlignItems.Center)
                justifyContent(JustifyContent.Center)
                property("flex-shrink", "0")
            }
        }) {
            PreviewIcon(iconPath, color = "#FFFFFF", size = 16)
        }

        H3(attrs = {
            style {
                width(0.px)
                property("flex", "1")
                property("min-width", "0")
                property("max-width", "100%")
                margin(0.px)
                fontSize(16.px)
                fontWeight("bold")
                color(Color("#000000"))
                lineHeight("1.3")
                property("white-space", "normal")
                property("overflow-wrap", "anywhere")
                property("word-break", "break-word")
            }
        }) {
            Text(title)
        }
    }
}

// Item générique pour Expériences / Stages / Cours / Activités / Certificats
@Composable
private fun Cv7ExpItem(
    title: String,
    company: String,
    city: String,
    period: String,
    bullets: List<String>,
    accentBlue: CSSColorValue,
    darkGray: CSSColorValue
) {
    Div(attrs = {
        style {
            width(100.percent)
            property("max-width", "100%")
            property("min-width", "0")
            marginBottom(12.px)
            position(Position.Relative)
        }
    }) {
        Div(attrs = {
            style {
                display(DisplayStyle.Flex)
                width(100.percent)
                property("max-width", "100%")
                property("min-width", "0")
                gap(8.px)
                alignItems(AlignItems.FlexStart)
            }
        }) {
            Div(attrs = {
                style {
                    width(0.px)
                    property("flex", "1")
                    property("min-width", "0")
                    property("max-width", "100%")
                    property("overflow-wrap", "anywhere")
                    property("word-break", "break-word")
                }
            }) {
                if (title.isNotBlank()) {
                    Div(attrs = {
                        style {
                            property("max-width", "100%")
                            fontWeight("bold")
                            fontSize(14.px)
                            lineHeight("1.3")
                            property("white-space", "normal")
                            property("overflow-wrap", "anywhere")
                            property("word-break", "break-word")
                        }
                    }) {
                        Text(title)
                    }
                }

                if (company.isNotBlank() || city.isNotBlank()) {
                    Div(attrs = {
                        style {
                            property("max-width", "100%")
                            color(accentBlue)
                            fontWeight("bold")
                            fontSize(12.px)
                            lineHeight("1.3")
                            property("white-space", "normal")
                            property("overflow-wrap", "anywhere")
                            property("word-break", "break-word")
                        }
                    }) {
                        Text(
                            listOfNotNull(
                                company.takeIf { it.isNotBlank() },
                                city.takeIf { it.isNotBlank() }
                            ).joinToString(" | ")
                        )
                    }
                }
            }

            if (period.isNotBlank()) {
                Div(attrs = {
                    style {
                        property("flex-shrink", "0")
                        property("max-width", "35%")
                        fontSize(11.px)
                        color(Color("#777777"))
                        fontWeight("bold")
                        textAlign(TextAlign.Right)
                        lineHeight("1.3")
                        property("white-space", "normal")
                        property("overflow-wrap", "anywhere")
                        property("word-break", "break-word")
                    }
                }) {
                    Text(period)
                }
            }
        }

        if (bullets.isNotEmpty()) {
            Ul(attrs = {
                style {
                    width(100.percent)
                    property("max-width", "100%")
                    property("min-width", "0")
                    paddingLeft(20.px)
                    margin(4.px, 0.px, 0.px)
                    fontSize(11.px)
                    color(darkGray)
                    property("box-sizing", "border-box")
                }
            }) {
                bullets.forEach { item ->
                    Li(attrs = {
                        style {
                            property("max-width", "100%")
                            marginBottom(6.px)
                            lineHeight("1.4")
                            property("white-space", "normal")
                            property("overflow-wrap", "anywhere")
                            property("word-break", "break-word")
                        }
                    }) {
                        HtmlInline(item)
                    }
                }
            }
        }
    }
}

@Composable
private fun Cv7PersonalizedSection(
    section: io.horion.cv.api.datasource.cv.Section,
    darkGray: CSSColorValue
) {
    val sectionTitle = section.title
        .ifBlank { "RUBRIQUE PERSONNALISÉE" }

    Cv7MainTitle(
        title = sectionTitle,
        iconPath = PreviewIcons.FILE_TEXT
    )

    Cv7SectionBody {
        Div(attrs = {
            style {
                property("width", "100%")
                property("max-width", "100%")
                property("min-width", "0")
                property("box-sizing", "border-box")
                property("overflow", "hidden")
                property("line-height", "1.5")
            }
        }) {
            if (section.resume.isNotBlank()) {
                Div(attrs = {
                    style {
                        property("width", "100%")
                        property("max-width", "100%")
                        property("min-width", "0")
                        property("font-size", "12px")
                        property("font-weight", "700")
                        property("color", Color("#000000"))
                        property("line-height", "1.4")
                        property("white-space", "normal")
                        property("overflow-wrap", "anywhere")
                        property("word-break", "break-word")
                    }
                }) {
                    Text(section.resume)
                }
            }

            if (
                section.started.isNotBlank() ||
                section.ended.isNotBlank()
            ) {
                Div(attrs = {
                    style {
                        property("width", "100%")
                        property("max-width", "100%")
                        property("min-width", "0")
                        property("font-size", "10px")
                        property("color", Color("#777777"))
                        property("line-height", "1.3")
                        property("margin-top", "3px")
                        property("margin-bottom", "5px")
                        property("white-space", "normal")
                        property("overflow-wrap", "anywhere")
                        property("word-break", "break-word")
                    }
                }) {
                    Text(
                        listOf(
                            section.started,
                            section.ended
                        )
                            .filter { it.isNotBlank() }
                            .joinToString(" — ")
                    )
                }
            }

            if (section.description.isNotBlank()) {
                Div(attrs = {
                    style {
                        property("width", "100%")
                        property("max-width", "100%")
                        property("min-width", "0")
                        property("font-size", "11px")
                        property("color", darkGray)
                        property("line-height", "1.6")
                        property("white-space", "normal")
                        property("overflow-wrap", "anywhere")
                        property("word-break", "break-word")
                        property("overflow", "hidden")
                    }
                }) {
                    HtmlBlock(section.description) {
                        property("width", "100%")
                        property("max-width", "100%")
                        property("min-width", "0")
                        property("font-size", "11px")
                        property("color", darkGray)
                        property("line-height", "1.6")
                        property("white-space", "normal")
                        property("overflow-wrap", "anywhere")
                        property("word-break", "break-word")
                    }
                }
            }
        }
    }
}